import React, { useEffect } from "react";

const CoinGeckoMarquee = () => {
  useEffect(() => {
    // Dynamically add the script tag
    const script = document.createElement("script");
    script.src =
      "https://widgets.coingecko.com/gecko-coin-price-marquee-widget.js";
    script.async = true;
    document.body.appendChild(script);

    // Cleanup the script when the component is unmounted
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>
      <gecko-coin-price-marquee-widget
        locale="en"
        outlined="true"
        coin-ids=""
        initial-currency="usd"
      ></gecko-coin-price-marquee-widget>
    </div>
  );
};

export default CoinGeckoMarquee;


